<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="员工工号">
                  <a-input placeholder="请输入员工工号" v-model="queryParam.employeeNo"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="员工姓名">
                  <a-input placeholder="请输入员工姓名" v-model="queryParam.name"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="健康码状态" >
                  <j-dict-select-tag v-model="queryParam.healthCode" dictCode="pre_health_status"/>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="核酸结果" >
                  <j-dict-select-tag v-model="queryParam.result" dictCode="pre_inspect_result"/>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :xl="10" :lg="11" :md="12" :sm="24">
                  <a-form-item label="核酸日期" >
                    <a-date-picker placeholder="开始时间" :allowClear="false" format=YYYY-MM-DD :disabled-date="disabledStart" class="query-group-cust" v-model="queryParam.detectionTime_begin"></a-date-picker>
                    <span class="query-group-split-cust"></span>
                    <a-date-picker placeholder="结束时间" :allowClear="false" format=YYYY-MM-DD :disabled-date="disabledEnd" class="query-group-cust" v-model="queryParam.detectionTime_end"></a-date-picker>
                  </a-form-item>
                </a-col>            
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" v-has="'preWorkData:search'"  @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" v-has="'preWorkData:reset'"  @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
     <!-- <a-button type="primary" icon="download" @click="handleExportXls('考勤管理')">导出</a-button> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
      </a-table>
    </div>

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {httpAction, getAction, postAction} from '@/api/manage'
  
  export default {
    name: 'WorkData',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '考勤查询',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'员工工号',
            align:"center",
            dataIndex: 'employeeNo'
          },
          {
            title:'员工姓名',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'事业群',
            align:"center",
            dataIndex: 'businessGroupName'
          },
          {
            title:'事业处',
            align:"center",
            dataIndex: 'businessUnitName'
          },
         /* {
            title:'部门',
            align:"center",
            dataIndex: 'department'
          }, */
          {
            title:'联系电话',
            align:"center",
            dataIndex: 'mobile'
          },          
          {
            title:'打卡时间',
            align:"center",
            dataIndex: 'checkInTime',
            /* customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            } */
          },
          {
            title:'卡钟编号',
            align:"center",
            dataIndex: 'machineNo'
          },
          {
            title:'卡钟对应楼栋',
            align:"center",
            dataIndex: 'machineLocation'
          },
          {
            title:'健康码状态',
            align:"center",
            dataIndex: 'healthCode_dictText',
            customRender:function (text,r,index) {
              if(text == null || text == "")
              {
                return "无记录";
              }
              else
              {
                return text;
              }
            }
          },
          {
             title:'核酸结果',
             align:"center",
             dataIndex: 'result_dictText',
             customRender:function (text,r,index) {
               if(text == null || text == "")
               {
                 return "无记录";
               }
               else
               {
                 return text;
               }
             }
          },
          {
             title:'核酸时态',
             align:"center",
             dataIndex: 'time',
             customRender:function (text,r,index) {
               if(r.detectionTime == null || r.detectionTime == "")
               {
                 return "无记录";
               }
               else
               {
                 return text;
               }
             }
          },
          {
             title:'最后一次核酸时间',
             align:"center",
             dataIndex: 'detectionTime',
             customRender:function (text,r,index) {
               if(text == null || text == "")
               {
                 return "无记录";
               }
               else
               {
                 return text;
               }
             }
          },
        ],
        url: {
          list: "/prevent/attendance/preattendances",
          exportXlsUrl: "/prevent/attendance/export-xls",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      disabledEnd(current){
        if(this.queryParam.detectionTime_begin != null)
        {
        return current < this.queryParam.detectionTime_begin;
        }
      },
      disabledStart(current){
        if(this.queryParam.detectionTime_end != null)
        {
        return current > this.queryParam.detectionTime_end;
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
